import {Component, inject, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IconService} from '@cov/ui-angular';
import {UserCentricsComponent} from './shared/ui/user-centrics/user-centrics.component';
import {GoogleTagmanagerComponent} from './shared/ui/google-tagmanager/google-tagmanager.component';
import {WalkMeComponent} from './shared/ui/walk-me/walk-me.component';
import {MaintenanceComponent} from './features/maintenance/maintenance.component';
import {MaintenanceService} from './shared/services/maintenance.service';

@Component({
  imports: [
    RouterModule,
    UserCentricsComponent,
    GoogleTagmanagerComponent,
    WalkMeComponent,
    MaintenanceComponent,
  ],
  selector: 'cov-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected maintenanceService = inject(MaintenanceService);
  private iconService = inject(IconService);

  public ngOnInit(): void {
    this.iconService.init();
  }
}
